import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelineDataPreviewPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPipelineDataPreviewPage',
  setup(__props) {

    document.title = "Pipeline data preview"

    const tid = useOrganizationUnitId()
    const id = useId()

    const { useCurrentUserQuery, usePipelineDataPreviewQuery } = useAdminPipelineDataPreviewPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDataPreviewQueryV1, modelPipelineDataPreviewQueryV1 } = usePipelineDataPreviewQuery(id)
    const preview = computed(() => modelPipelineDataPreviewQueryV1.value)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDataPreviewQueryV1()
    })

return { __sfc: true,tid, id, useCurrentUserQuery, usePipelineDataPreviewQuery, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDataPreviewQueryV1, modelPipelineDataPreviewQueryV1, preview }
}

})